export default "__VITE_ASSET__22effc48__"